import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ButtonComponent, LangService, LoaderService, NavigateService} from '@satoris/ngx-satoris';
import {ApiService} from '../../shared/services/api.service';
import {OtpType} from 'src/app/shared/models/user';
import {Router} from '@angular/router';
import {truncateString} from 'src/app/shared/utils/string';

const RESEND_WAIT_S = 60;

@Component({
  selector: 'app-account-valid',
  templateUrl: './account-valid.component.html',
  styleUrls: ['./account-valid.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AccountValidComponent implements OnInit {
  @ViewChild('buttonResendOtp', {static: true}) buttonResendOtp: ButtonComponent;

  data: {
    signType: OtpType,
    accountToActivate: string,
    resendAt?: number,
  };
  truncateString = truncateString;
  OtpType = OtpType;
  JSON = JSON;
  isSubmitting = false;

  constructor(public nav: NavigateService,
    public api: ApiService,
    private loader: LoaderService,
    private lang: LangService,
    private router: Router) {
    this.data = <any> this.router.getCurrentNavigation()?.extras?.state;
    if(!this.data?.accountToActivate && !this.data?.signType) {
      this.nav.to('home');
    }
  }

  ngOnInit() {
    if(!this.data) return;
    // The first resend waits like the next ones; the deadline lives in the navigation state, which the language screen hands back.
    this.data.resendAt ??= Date.now() + RESEND_WAIT_S * 1000;
    this.waitForResend();
  }

  private waitForResend() {
    const seconds = Math.ceil((this.data.resendAt - Date.now()) / 1000);
    if(seconds <= 0) return;
    this.buttonResendOtp.disableTime = seconds;
    this.buttonResendOtp.startTimer();
  }

  resendLink() {
    if(this.isSubmitting) return;
    this.isSubmitting = true;
    // The wait starts on the tap, before the answer: a trip to the language screen meanwhile takes this deadline along, not the expired one.
    this.data.resendAt = Date.now() + RESEND_WAIT_S * 1000;
    this.waitForResend();
    this.api.rearm(this.data.accountToActivate).then(() => {
      this.loader.loading(true, {type: 'valid', message: this.lang.transform(this.data.signType === OtpType.EMAIL ? 'otp.successResend.email' : 'otp.successResend.sms')});
    }, () => {
      this.loader.loading(true, {type: 'error', message: this.lang.transform('global.error')});
    }).finally(() => this.isSubmitting = false);
  }
}
